import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import LendingAPI from '../api/lendingAPI/LendingAPI.reducer';
import IwIntlProvider from '../iwIntlProvider/IwIntlProvider.reducer';
import Modals from '../iwModals/Modals.reducer';
import IwRouter from '../iwRouter/IwRouter.reducer';
import IwSiteContext from '../iwSiteContext/IwSiteContext.reducer';
import ApplyFlexiLoanView from '../myAccount/applyFlexiLoanView/ApplyFlexiLoanView.reducer';
import CBILSDashboard from '../myAccount/CBILS/dashboard/Dashboard.reducer';
import Dashboard from '../myAccount/dashboard/Dashboard.reducer';
import DrawDown from '../myAccount/drawDown/DrawDown.reducer';
import EarlyRepayment from '../myAccount/earlyRepayment/EarlyRepayment.reducer';
import AddPaymentMethodModal from '../myAccount/modals/addPaymentMethodModal/AddPaymentMethodModal.reducer';
import EditPaymentMethodModal from '../myAccount/modals/editPaymentMethodModal/EditPaymentMethodModal.reducer';
import IdCheckVerificationModal from '../myAccount/modals/idCheckVerificationModal/IdCheckVerificationModal.reducer';
import LinkOpenBankingModal from '../myAccount/modals/linkOpenBankingModal/LinkOpenBankingModal.reducer';
import ManualPaymentModal from '../myAccount/modals/manualPaymentModal/ManualPaymentModal.reducer';
import PersonModal from '../myAccount/modals/personModal/PersonModal.reducer';
import ProcessingPaymentModal from '../myAccount/modals/processingPaymentModal/ProcessingPaymentModal.reducer';
import RepaymentScheduleModal from '../myAccount/modals/repaymentScheduleModal/RepaymentScheduleModal.reducer';
import UploadDocumentsModal from '../myAccount/modals/uploadDocumentsModal/UploadDocumentsModal.reducer';
import Profile from '../myAccount/Profile/Profile.reducer';
import RLSDashboard from '../myAccount/RLS/dashboard/Dashboard.reducer';

const RootReducer = combineReducers({
    siteContext: IwSiteContext,
    intl: IwIntlProvider,
    history: IwRouter,
    dashboard: Dashboard,
    profile: Profile,
    drawDown: DrawDown,
    earlyRepayment: EarlyRepayment,
    modals: Modals,
    repaymentScheduleModal: RepaymentScheduleModal,
    addPaymentMethodModal: AddPaymentMethodModal,
    editPaymentMethodModal: EditPaymentMethodModal,
    personModal: PersonModal,
    manualPaymentModal: ManualPaymentModal,
    processingPaymentModal: ProcessingPaymentModal,
    uploadDocumentsModal: UploadDocumentsModal,
    linkOpenBankingModal: LinkOpenBankingModal,
    idCheckVerificationModal: IdCheckVerificationModal,
    api: LendingAPI,
    form: formReducer,
    CBILSDashboard: CBILSDashboard,
    applyFlexiLoanView: ApplyFlexiLoanView,
    RLSDashboard: RLSDashboard
});

// eslint-disable-next-line import/no-default-export
export default RootReducer;
